export const TOAST_DISMISS = 'TOAST_DISMISS';
export const TOAST_MESSAGE = 'TOAST_MESSAGE';
export const TOAST_UPDATE = 'TOAST_UPDATE';